import { useLocalization } from '@/hooks/useLocalization';
import { useTranslations } from 'next-intl';
import { Button } from '../../../../../components/design-system';
import {
  ChevronDown as IconChevronDown,
  Location as IconLocation,
  Search as IconSearch,
} from '../../../../../components/icons';
import AddressModal from './AddressModal/AddressModal';
import DeliveryTimeLabel from './AddressModal/DeliveryTimeLabel';
import useAddressSearch from './AddressModal/hook';
import SearchModal from './SearchModal/SearchModal';

export default function MagicBar() {
  const t = useTranslations('shop');
  const tc = useTranslations('common');
  const localization = useLocalization();
  const { updateGlobalLocation } = useAddressSearch('');

  return (
    <div
      className={`
      w-full md:max-w-sm lg:max-w-xl h-12 md:h-13 mx-auto
      flex items-center rounded-2xl overflow-hidden
      bg-greyscale-background border border-greyscale-separator
    `}
    >
      <AddressModal
        showSavedAddresses
        showLastAddress
        onChangeAddress={async (location) => {
          await updateGlobalLocation(location);
        }}
        renderTrigger={({ open }) => (
          <div
            className="flex-1 lg:flex-none lg:w-64 h-full flex items-center gap-1 px-2.5 z-10 cursor-pointer overflow-hidden hover:bg-gray-200 outline outline-transparent hover:outline-gray-200"
            onClick={open}
            role="button"
          >
            <IconLocation className="text-greyscale-placeholder shrink-0" />
            <div className="flex-1 overflow-hidden">
              {localization.location?.formattedAddress ? (
                <>
                  <div className="flex items-center">
                    <div
                      className={`flex-1 text-sm md:text-base ${
                        localization.location.label
                          ? 'font-bold'
                          : 'font-medium'
                      } tracking-tight text-greyscale-body truncate`}
                    >
                      {localization.location.label ||
                        localization.location.formattedAddress}
                    </div>
                    <IconChevronDown className="h-5" />
                  </div>
                  <div className="text-xs md:text-sm text-greyscale-placeholder font-medium tracking-tight leading-4">
                    <DeliveryTimeLabel />
                  </div>
                </>
              ) : (
                <div className="flex-1 text-sm md:text-base font-medium tracking-tight text-greyscale-body truncate">
                  {tc('address.insert')}
                </div>
              )}
            </div>
          </div>
        )}
      />
      <div className="w-px h-8 bg-greyscale-separator" />
      <SearchModal
        renderTrigger={({ open }) => (
          <div
            className="flex-1 w-full h-full flex items-center justify-between gap-1 px-2.5 z-10 cursor-pointer overflow-hidden hover:bg-gray-200 outline outline-transparent hover:outline-gray-200"
            onClick={open}
            role="button"
          >
            <span className="text-sm md:text-base font-medium tracking-tight text-greyscale-placeholder">
              {t('search.title')}
            </span>
            <Button
              className="hidden md:block"
              rounded
              type="submit"
              variant="icon"
            >
              <IconSearch />
            </Button>
          </div>
        )}
      />
    </div>
  );
}
